import { Type } from '@warp-drive/core-types/symbols';
import RecommendationStrategy from 'lumen/models/recommendation-strategy';

export default class ConditionalStrategy extends RecommendationStrategy {
  // @ts-expect-error: Class inheritance
  [Type] = 'conditional-strategy' as const;

  get hasInvalidPriceRangeCondition(): boolean {
    if (!this.conditions) {
      return true;
    }

    // Currently the only supported price range condition structure
    if (
      this.conditions &&
      this.conditions.condition_type === 'operand' &&
      this.conditions.first.condition_type === 'computed_value' &&
      this.conditions.second.condition_type === 'user_editable_value'
    ) {
      if (
        !this.conditions.operation ||
        !this.conditions.first.name ||
        this.conditions.second.value === null
      ) {
        return true;
      }
    }

    return false;
  }

  get isConditionalStrategy(): boolean {
    return true;
  }
}
